import {useContext} from 'react';

import {SigninOptionsContext} from 'context/SigninOptionsContext';

export const useDefaultSigninOption = () => {
    return useContext(SigninOptionsContext);
};
